export enum DatasetMetadataType {
  HirundoCSV = 'HirundoCSV',
  MultimodalHirundoCSV = 'MultimodalHirundoCSV',
  COCO = 'COCO',
  YOLO = 'YOLO',
  HuggingFaceAudio = 'HuggingFaceAudio',
  HuggingFaceDataset = 'HuggingFaceDataset',
}
